import { Component, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-rating',
  templateUrl: './rating.page.html',
  styleUrls: ['./rating.page.scss'],
})
export class RatingPage implements OnInit {

  //is it a pricepilot booking
  pricepilot = false;


  //is it a dm survey
  dm = false;

  //is it a dm survey
  dermacenter = false;

  constructor( private metaService: Meta, private route: ActivatedRoute, private titleService: Title, public translateService: TranslateService ) { 
    this.titleService.setTitle('Anketa o zadovoljstvu obiskane restavracije');
  }

  onChange( $event ) {
    this.translateService.use($event.detail.value);
  }

  ngOnDestroy() {
    this.titleService.setTitle('');
  }


  ngOnInit() {

    this.metaService.updateTag({ property: 'og:title', content: 'Anketa o zadovoljstvu obiskane restavracije' });
    
    this.titleService.setTitle('Anketa o zadovoljstvu obiskane restavracije');

    this.pricepilot = this.route.snapshot.queryParams.pricepilot?true:false; 
    this.dm = this.route.snapshot.queryParams.dm?true:false; 
    this.dermacenter = this.route.snapshot.queryParams.dermacenter?true:false; 
    
   
    

  }

}
